import { EditOutlined, TransactionOutlined } from "@ant-design/icons";
import ContaViagem from "../../../../../Models/Domain/Viagem/Financeiro/ContaViagem";
import Ordenar from "../../../../../Utils/Ordenacao";
import Utilitario from "../../../../../Utils/Utilitario";
import { Button, Flex } from "antd";
import { extractorNomePessoa } from "../../../../../Models/Pessoa/Pessoa";
import TablePaginadaBasic, { ITablePaginadaBasicProps } from "../../../../Base/Table/TablePaginadaBasic";
import MovimentacaoForm from "@/Components/Populados/Financeiro/Conta/Movimentacao/MovimentacaoForm";
import DrawerBasic, { IDrawerBasicRef } from "@/Components/Base/Drawer/DrawerBasic";
import { useRef } from "react";
import ContaEncerramento from "@/Components/Populados/Financeiro/Conta/ContaEncerramento";
import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import ContaViagemForm from "./ContaViagemForm";
import { ContaViagemSituacoesDicionario, EnumContaViagemSituacao } from "@/Models/Domain/Viagem/Financeiro/ContaViagem/ContaViagemSituacao";
import ContaViagemAlterarSituacao from "./ContaViagemAlterarSituacao";
import { ContaViagemSituacoesDicionarioProximaAcao } from "@/Models/Domain/Viagem/Financeiro/ContaViagem/ContaViagemSituacao";

type OnSuccessType = (acao:'alterarSituacao'|'movimentar'|'editar') => void;
export interface IContaViagemTableProps extends Omit<ITablePaginadaBasicProps<ContaViagem>, "rowKey"> {
    onSuccess ?: OnSuccessType;
    opcaoEncerraFixa ?: boolean;
}
export default function ContaViagemTable({
    columns,
    bordered,
    locale,
    loading,
    size,
    onSuccess,
    opcaoEncerraFixa,
    ...props
}:IContaViagemTableProps) {
    return <TablePaginadaBasic
        {...props}
        bordered={bordered ?? true}
        locale={{ ...locale, emptyText: locale?.emptyText ?? 'Nenhuma conta ADV encontrada.' }}
        loading={loading}
        rowKey={(k) => k.codigo}
        size={size === undefined ? "small" : size}
        showHeader={true}
        disableResponsiveness={true}
        tableLayout="auto"
        scroll={{
            x : undefined,
            y : "70vh"
        }}
        columns={[
            {
                title: "Conta",
                dataIndex: ["conta", "nome"],
                minWidth: "200px",
                key: 50
            },
            {
                title: "Centro de custo",
                dataIndex: ["centroCusto", "descricao"],
                minWidth: "200px",
                key: 51
            },
            {
                title: "Viagem",
                dataIndex: ["viagem", "titulo"],
                minWidth: "200px",
                key: 52
            },
            {
                title: "Situação",
                dataIndex: ["codSituacao"],
                minWidth: "80px",
                render : (value:EnumContaViagemSituacao, _, __) => ContaViagemSituacoesDicionario[value],
                key: 53
            },
            {
                title : "Ações",
                minWidth: "220px",
                dataIndex : ["codigo"],
                render(value:number, record:ContaViagem) {
                    return <OpcoesContaViagem contaViagem={record} onSuccess={onSuccess} opcaoEncerraFixa={opcaoEncerraFixa} />;
                },
                key : 54
            },
            ...(columns ?? [])
        ].sort((coluna1, coluna2) => Ordenar.Numero(Number(coluna1.key), Number(coluna2.key)))}
    />
}

export function OpcoesContaViagem({
    contaViagem,
    onSuccess,
    opcaoEncerraFixa
}:{
    contaViagem:ContaViagem;
    onSuccess ?: OnSuccessType;
    opcaoEncerraFixa ?: boolean;
}) {
    const refNova = useRef<IDrawerBasicRef>(null);
    const refEditarContaViagem = useRef<IDrawerBasicRef>(null);
    return <Flex vertical={false} wrap="wrap" gap={"small"}>
        {!contaViagem.conta?.encerrada && <DrawerBasic
            ref={refNova}
            elementoGatilho={<span>
                <Button type="dashed" size="small" icon={<TransactionOutlined />}>Saldo</Button>
            </span>}
            destroyOnClose={true}
        >
            <MovimentacaoForm
                disable={{
                    movimentacao : {
                        codConta : true
                    }
                }}
                initialValues={{
                    movimentacao : {
                        codConta : contaViagem.codConta
                    }
                }}
                onCancelar={(e) => {
                    refNova.current?.fechar(e);
                }}
                onSuccess={() => {
                    refNova.current?.fechar({} as any);
                    onSuccess?.('movimentar');
                }}
            />
        </DrawerBasic>}
        <ComponentePermissao permissoes={["DomainViagemFinanceiroContaViagemEditar"]}>
            <DrawerBasic
                ref={refEditarContaViagem}
                elementoGatilho={<span>
                    <Button type="primary" size="small">Editar</Button>
                </span>}
                destroyOnClose={true}
            >
                <ContaViagemForm
                    codigo={contaViagem.codigo}
                    onCancelar={(e) => {
                        refEditarContaViagem.current?.fechar(e);
                    }}
                    onSuccess={() => {
                        refEditarContaViagem.current?.fechar({} as any);
                        onSuccess?.('editar');
                    }}
                />
            </DrawerBasic>
        </ComponentePermissao>
        <ContaViagemAlterarSituacao 
            codContaViagem={contaViagem.codigo}
            codSituacao={ContaViagemSituacoesDicionarioProximaAcao[contaViagem.codSituacao]}
            onSuccess={() => onSuccess?.('alterarSituacao')}
        />
        {
            (
                opcaoEncerraFixa 
                && ContaViagemSituacoesDicionarioProximaAcao[contaViagem.codSituacao] != EnumContaViagemSituacao.Encerrado 
                && contaViagem.codSituacao != EnumContaViagemSituacao.Encerrado
            ) && <ContaViagemAlterarSituacao 
                codContaViagem={contaViagem.codigo}
                codSituacao={EnumContaViagemSituacao.Encerrado}
                onSuccess={() => onSuccess?.('alterarSituacao')}
            />
        }
    </Flex>;
}